<template>
  <div>
    <PushNotificationMessageCreateForm
      v-if="isPushNotificationsCreateFormVisible"
      :toggleCreateForm="toggleCreateForm"
      :message="selectedGroupData.chosenCampaignMessage"
      :index="selectedGroupData.chosenCampaignMessageIndex"
      v-on:pn_message_update="message_update_callback"
      v-on:pn_message_add="message_add_callback"
    />
    <v-container fluid class="pa-0">
      <v-row no-gutters>
        <v-col cols="auto" class="pa-0">
          <MainMenu></MainMenu>
        </v-col>
        <v-col cols="auto" class="pa-2">
          <v-btn color="green"
                 v-on:click="createNewGroup">
            Creat a new one
          </v-btn>
          <v-list>
            <v-subheader>Existing push notifications</v-subheader>
            <v-list-item-group v-model="selectedGroup" @change="flushData">
              <v-list-item v-for="item in groups"
                           :key="item.name"
                           :value="item">
                <v-list-item-content>
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col align-self="stretch" class="pa-2">
          <v-row>
            <v-select label="Select a campaign please"
                      v-model="selectedCampaign"
                      :items="campaignsData"
                      :disabled="selectedGroup === null"
                      outlined
                      dense
                      hide-selected
                      @change="getCampaignData">
            </v-select>
          </v-row>
          <v-row>
            <v-tabs show-arrows
                    :grow="true"
                    :centered="true">
              <v-tabs-slider></v-tabs-slider>
              <v-tab key="mainTab"
                     href="#tab-main">Messages and Analytics Data
              </v-tab>
              <v-tab key="marketingTab"
                     href="#tab-marketing">Compiled Marketing Data
              </v-tab>
              <v-tab-item key="mainTab"
                          value="tab-main">
                <v-container fluid v-if="selectedCampaign">
                  <v-card>
                    <v-card-title>Upload Campaign DATA file here
                    </v-card-title>
                    <v-card-subtitle>
                      <span class="form__important-text">any with *.csv extension</span>
                    </v-card-subtitle>
                    <v-card-text>
                      <input
                        type="file"
                        :class="{'form__input': true, 'is-error': errors.has('dataFile')}"
                        v-validate="filesRules"
                        ref="dataFileInput"
                        name="dataFile"
                        @change="processFile($event, 'dataFile')"
                      >
                      <span class="form__error" v-show="errors.has('dataFile')">{{ errors.first('dataFile') }}</span>
                    </v-card-text>
                  </v-card>
                  <v-row justify="end">
                    <v-btn class="ma-2"
                           v-if="$checkRoles(['Administrator']) && selectedCampaign"
                           color="green"
                           v-on:click="toggleCreateForm(true)">
                      Create a new message
                    </v-btn>
                  </v-row>
                  <v-card>
                    <v-card-text>Messages table</v-card-text>
                    <v-simple-table fixed-header height="60vh"
                                    v-if="selectedGroupData.chosenCampaignMessages.length">
                      <template v-slot:default>
                        <thead>
                        <tr>
                          <th class="text-left">Timing</th>
                          <th class="text-left">Message</th>
                          <th class="text-left">arkpromos</th>
                          <th class="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(pushNotification, index) in selectedGroupData.chosenCampaignMessages" :key="index"
                            class="games__item">
                          <td>{{pushNotification.timing}}</td>
                          <td>{{pushNotification.message}}</td>
                          <td>{{pushNotification.arkpromos}}</td>
                          <td class="column-actions">
                            <v-btn v-if="$checkRoles(['Administrator'])"
                                   @click="editMessage(pushNotification, index)"
                                   color="green">
                              <span>Edit</span>
                            </v-btn>
                            <v-btn v-if="$checkRoles(['Administrator'])"
                                   @click="removePushNotification(index)"
                                   color="red">
                              <span>Delete</span>
                            </v-btn>
                          </td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                  <v-row justify="end">
                    <v-btn class="ma-2" v-if="$checkRoles(['Administrator'])"
                           v-on:click="SendDataCompileRequest"
                           :loading="isLoadingBtn"
                           color="red">
                      Send compile Data request
                    </v-btn>
                    <v-btn class="ma-2"
                           v-if="$checkRoles(['Administrator'])"
                           v-on:click="SaveData"
                           :loading="isLoadingBtn"
                           color="green">
                      Save All Data
                    </v-btn>
                  </v-row>
                </v-container>
              </v-tab-item>
              <v-tab-item key="marketingTab"
                          value="tab-marketing">
                <div>
                  <v-card class="ma-2">
                    <v-card-title>Data file information:</v-card-title>
                    <v-card-text>
                      Updated: {{selectedGroupData.marketingData.updateDateTime ?
                      selectedGroupData.marketingData.updateDateTime : 'N/A'}}
                      <a style="cursor: pointer" v-if="selectedGroupData.marketingData.updateDateTime"
                         v-on:click="downloadMarketingFile">Download Marketing Data File</a>
                    </v-card-text>
                  </v-card>
                  <v-simple-table fixed-header height="60vh">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Title</th>
                        <th>Message</th>
                        <th>URL</th>
                        <th>NotificationImage</th>
                        <th>BigImage</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(data, index) in selectedGroupData.marketingData.data" :key="index"
                          class="games__item">
                        <td>{{data.Title}}</td>
                        <td>{{data.Message}}</td>
                        <td>{{data.URL}}</td>
                        <td>{{data.NotificationImage}}</td>
                        <td>{{data.BigImage}}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </v-tab-item>
            </v-tabs>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  /* eslint-disable indent-legacy */

  import PushNotificationMessageCreateForm from './PushNotificationItemPopup.vue';
  import config from '../../config'
  import MainMenu from '../MainMenu/MainMenu.vue';

  function initialState () {
    return {
      dataFile: null,
      chosenCampaignMessages: [],
      chosenCampaignMessage: null,
      chosenCampaignMessageIndex: null,
      marketingData: {}
    }
  }

  export default {
    name: 'PushNotifications',
    components: {MainMenu, PushNotificationMessageCreateForm},
    data () {
      return {
        selectedGroup: null,
        groups: [],
        selectedCampaign: null,
        isPushNotificationsCreateFormVisible: false,
        successMsgs: [],
        errorMsgs: [],
        isLoadingBtn: false,
        saveError: '',
        selectedGroupData: initialState()
      }
    },
    computed: {
      filesRules () {
        return {
          ext: 'csv',
          required: false
        }
      },
      campaignsData: function () {
        if (!this.selectedGroup) {
          return []
        }
        let campaigns = this.selectedGroup.campaigns
        let keys = Object.keys(campaigns)
        return keys.map(item => {
          return {text: item, value: campaigns[item].name}
        })
      }
    },
    created: function () {
      this.getPushNotificationsMeta()
    },
    methods: {
      createNewGroup: function () {
        async function createNewGroup (newGroupName) {
          if (newGroupName) {
            let formData = new FormData()
            formData.append('jsonData', JSON.stringify(
              {
                Group: newGroupName
              }
            ))

            await this.$http
              .post(`${config.apiUrl}/pushnotifications/create-group`, formData)
              .then(() => {
                this.$swal.fire({
                  icon: 'success',
                  title: 'Success!',
                  text: 'New group was created successfully'
                })
              }, error => {
                console.log(error)
              })
          }
        }

        this.$swal.fire({
          title: 'Please type the new group name',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Create',
          showLoaderOnConfirm: false
        }).then(async (result) => {
            let newGroupName = result.value
            await createNewGroup.bind(this)(newGroupName)
          }
        ).then(_ => {
          this.flushData()
          this.getPushNotificationsMeta()
        })
      },
      downloadMarketingFile: function () {
        let campaign = encodeURIComponent(this.selectedCampaign)
        this.$http.get(`${config.apiUrl}/pushnotifications/marketing-data-download?campaign=${campaign}&group=${this.selectedGroup.name}`)
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'marketing-data.csv')
            document.body.appendChild(link)
            link.click()
          })
      },
      processFile: function (e, file) {
        this[file] = e.target.files[0] // adding file to this.messagesFile or this.dataFile
      },
      getMarketingData: function () {
        let campaign = encodeURIComponent(this.selectedCampaign)
        this.$http.get(`${config.apiUrl}/pushnotifications/marketing-data?campaign=${campaign}&group=${this.selectedGroup.name}`)
          .then(response => {
            this.selectedGroupData.marketingData = response.body
          }, error => {
            console.log(error)
          })
      },
      flushData: function () {
        Object.assign(this.$data.selectedGroupData, initialState())
        this.selectedCampaign = null
      },
      getCampaignData: function () {
        if (this.selectedCampaign && this.selectedGroup) {
          this.getCampaignPushNotifications()
          this.getMarketingData()
        }
      },
      getPushNotificationsMeta: function () {
        this.$http.get(`${config.apiUrl}/pushnotifications/campaigns-list`)
          .then(response => {
            let data = response.body
            this.groups = data.items || []
          }, error => {
            console.log(error)
          })
      },
      getCampaignPushNotifications: function () {
        let campaign = encodeURIComponent(this.selectedCampaign)
        this.$http.get(`${config.apiUrl}/pushnotifications/raw-data-list?campaign=${campaign}&group=${this.selectedGroup.name}`)
          .then(response => {
            this.selectedGroupData.chosenCampaignMessages = response.body
          }, error => {
            console.log(error)
          })
      },
      toggleCreateForm: function (bool) {
        if (bool === false) {
          this.selectedGroupData.chosenCampaignMessage = null
        }
        this.isPushNotificationsCreateFormVisible = bool
      },
      removePushNotification: function (index) {
        this.selectedGroupData.chosenCampaignMessages.splice(index, 1)
      },
      editMessage: function (item, index) {
        this.selectedGroupData.chosenCampaignMessage = item
        this.selectedGroupData.chosenCampaignMessageIndex = index
        this.toggleCreateForm(true)
      },
      message_update_callback: function (index, msg) {
        this.selectedGroupData.chosenCampaignMessages[index] = msg
      },
      message_add_callback: function (msg) {
        this.selectedGroupData.chosenCampaignMessages.push(msg)
      },
      SaveData: function () {
        this.$validator.validateAll().then((isValid) => {
          if (isValid) {
            this.isLoadingBtn = true
            const formData = new FormData()
            formData.append('jsonData', JSON.stringify({
              'Group': this.selectedGroup.name,
              'Campaign': this.selectedCampaign,
              'RawData': this.selectedGroupData.chosenCampaignMessages
            }))

            if (this.dataFile) formData.append('data.cvs', this.dataFile)

            this.$http
              .post(`${config.apiUrl}/pushnotifications/save-data`, formData)
              .then(response => {
                // parse response here
                this.arenaIsEdited = true
                this.$refs.dataFileInput.value = '' // clearing input after success
              }, error => {
                this.saveError = error.body.Message ? error.body.Message : 'Something went wrong while files uploading or verification'
              })
              .then(_ => {
                this.isLoadingBtn = false
              })
          }
        })
      },
      SendDataCompileRequest: function () {
        this.isLoadingBtn = true
        const formData = new FormData()
        formData.append('JsonData', JSON.stringify({
          'Group': this.selectedGroup.name
        }))

        this.$http
          .post(`${config.apiUrl}/notification/request-pushnotifications-update`, formData)
          .then(response => {
            this.$swal.fire(
              'Good job! Wait several minutes for the result',
              'Your push notification compile request was sent successfully. ',
              'success'
            )
            // parse response here
          }, error => {
            this.$swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Create push notifications compile request error. Please contact WebPortals'
            })
          })
          .then(_ => {
            this.isLoadingBtn = false
          })
      }
    }
  }
</script>
